import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ApiService} from '../../api/api.service';
import {Observable} from 'rxjs';
import {CustomerConfig} from 'smag-commons/dto/api';

@Injectable()
export class CustomerConfigResolverService implements Resolve<CustomerConfig> {

    constructor(private readonly api: ApiService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CustomerConfig> {
        const totp = route.queryParamMap.get('totp');
        return this.api.getCustomerConfig(totp);
    }
}
